import { useTheme } from "@mui/material";
import { createSxStyles } from "../../../common/createSxStyles";

export const useSettingsLayoutStyles = () => {
    const theme = useTheme();
    return createSxStyles({
        container: {
            display: "flex",
            height: "100%",
            flex: 1,
        },
        content: {
            flex: 1,
            overflow: "auto",
            paddingLeft: theme.spacing(2),
        },
    });
};
